import { VISUALIZATION_TYPES } from "../../../constants/reportBuilder.js";
import { rbSectionHint } from "../reportBuilderTheme.js";

const VIZ_ICONS = {
  table: "▦",
  bar: "▮",
  line: "⌇",
  pie: "◔",
  map: "⌖",
};

export function VisualizationStep({ visualization, onSelect, c, A }) {
  return (
    <div>
      <p style={rbSectionHint(c)}>Pick an output format for the saved report and exports.</p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 10 }}>
        {VISUALIZATION_TYPES.map((v) => {
          const selected = visualization === v.id;
          return (
            <button
              key={v.id}
              type="button"
              onClick={() => onSelect(v.id)}
              style={{
                textAlign: "left",
                padding: "14px 16px",
                borderRadius: 12,
                border: `2px solid ${selected ? A : c.cardBdr}`,
                background: selected ? `${A}10` : c.card,
                cursor: "pointer",
              }}
            >
              <div style={{ fontSize: 22, marginBottom: 8, color: selected ? A : c.sub }}>{VIZ_ICONS[v.id]}</div>
              <div style={{ fontSize: 13, fontWeight: 700, color: c.text, marginBottom: 4 }}>{v.label}</div>
              <div style={{ fontSize: 11, color: c.sub, lineHeight: 1.4 }}>{v.description}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
